import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { LoadingService } from '@mds/ngx-core';
import { finalize, first } from 'rxjs';
import { ShiftResponse, ShiftsClient } from '../../../shared';

export const shiftResolver: ResolveFn<ShiftResponse | undefined> = (
  route: ActivatedRouteSnapshot,
) => {
  const shiftsClient = inject(ShiftsClient);
  const loadingService = inject(LoadingService);

  const idRaw = route.queryParamMap.get('shiftId');
  const shiftId = Number(idRaw);
  if (shiftId <= 0) return undefined;

  return shiftsClient.getShiftById(shiftId).pipe(
    first(),
    finalize(() => loadingService.end()),
  );
};
